import { render } from "./stock-market.vue?vue&type=template&id=456765b8&scoped=true"
import script from "./stock-market.vue?vue&type=script&lang=js"
export * from "./stock-market.vue?vue&type=script&lang=js"

import "./stock-market.vue?vue&type=style&index=0&id=456765b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456765b8"]])

export default __exports__